﻿export function initHeaderShell() {
    const header = document.querySelector(".site-header");
    if (!header) return;

    const onScroll = () => {
        header.classList.toggle("is-scrolled", window.scrollY > 12);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
}